export default {
  path: "*",
  name: "Error408",
  component: () => import("@/views/ErrorPages/Error408"),
  meta: {
    middleware_excemption: true
  }
};
